import { useSelector } from 'react-redux';

const useProfile = () => {
  return useSelector((state) => state.user);
}

export default useProfile;
